export default "__VITE_ASSET__BS_pJqb9__"